import { DefaultRealtimeDataMode } from '../../configs/GlobalConfig';

export const KEY_REALTIMEDATAMODE = 'realtimeDataMode';

export const getRealtimeDataMode = () => {
  return +localStorage.getItem(KEY_REALTIMEDATAMODE) || DefaultRealtimeDataMode;
};

export const saveRealtimeDataMode = realtimeDataMode => {
  localStorage.setItem(KEY_REALTIMEDATAMODE, realtimeDataMode);
};
